import { defineAction } from '~/prix'
import citizenFetchQuestionnaireAction from './citizenFetchQuestionnaire.action.json' with { type: 'json' }
import { citizenObject } from '../citizenObject'
import { citizenExpression } from '../list/citizenList.definition'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const citizenFetchQuestionnaireDefinition = defineAction({
  ...citizenFetchQuestionnaireAction,
  input: z.object({
    id: z.string().uuid(),
  }),
  output: z.object({
    ...citizenObject.shape,
    questionnaires: z.array(
      z.object({
        id: z.number(),
        title: z.string(),
        observation: z.string().nullish(),
        lgpdDisclaimer: z.string().nullish(),
        targetType: z.string().nullish(),
        targetPublic: citizenExpression,
        delimitationType: z.string().nullish(),
        delimitationId: z.number().nullish(),
        delimitationCustom: z.string().nullish(),
        startDate: dateOrIsoString().nullish(),
        endDate: dateOrIsoString().nullish(),
        createdAt: dateOrIsoString().nullish(),
        updatedAt: dateOrIsoString().nullish(),
        deletedAt: dateOrIsoString().nullish(),
      }),
    ),
  }),
})

export default citizenFetchQuestionnaireDefinition
